import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import SignupEmail from '@/components/UI/svg/Icons/SignupEmail';

export default function SignupPopupIcon({ changeStatu }: any) {
    const handleClick = () => {
        changeStatu(1);
    };

    return (
        <div className={`signup-popup-icon ${css['signup-popup-icon']} signup-icon-pc`} onClick={handleClick}>
            <div className="icon">
                <SignupEmail />
            </div>
        </div>
    );
}
